// Regras de status de pagamento compartilhadas entre Painel, Financeiro e OS.
export function calcTotalPago(servico) {
  return (servico.pagamentos || []).reduce((a, p) => a + (p.valor || 0), 0);
}

export function statusPagamento(servico) {
  const pago = calcTotalPago(servico);
  const total = servico.totalGeral || 0;
  if (pago <= 0) return 'pendente';
  if (pago >= total - 0.01) return 'pago';
  return 'parcial';
}

// Uma OS concluída com pagamento parcial ainda não está 100% quitada — para
// fins de alertas/contadores ela conta como pendente, igual a "sem pagamento".
export function pagamentoEmAberto(servico) {
  return servico.status === 'concluido' && statusPagamento(servico) !== 'pago';
}
